/**
 * routerName
 */
export const LAYOUT = "LAYOUT";
export const HOME = "HOME";
export const LIVE_TV = "LIVE_TV";
export const META_LIST = "META_LIST";
export const META_DETAIL = "META_DETAIL";
export const VOD_CATEGORY = "VOD_CATEGORY";
export const VOD_DETAIL = "META_DETAIL";
export const FAVORITES = "FAVORITE";
export const HISTORY = "HISTORY";
export const SEARCH = "SEARCH";
export const FILTER = "FILTER";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const MY = "MY";
export const ACCOUNT = MY + "ACCOUNT";
export const PLAN = MY + "PLAN";
export const SUBSCRIBE = MY + "SUBSCRIBE";
export const WELCOME = "WELCOME";
export const SETTING = MY + "SETTING";
export const INFO = MY + "INFO";

